import { useEffect, useState } from "react";
import { Select } from "@arco-design/web-react";

const uomList = [
    'lb.',
    'kg.',
    'g.',
    'ft.',
    'inch.',
    'm.',
    'mm.',
    'each',
    'cs'
];

export const getUOMOptions = (disabledList = []) => {
    return uomList.map(uom => ({
        label: uom,
        value: uom,
        disabled: disabledList.includes(uom)
    }));
};

export const getUOMByName = (name) => {
    return uomList.find(uom => uom === name);
};

const UOMSelect = (props) => {
    const { disabledList, ...rest } = props;
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const options = getUOMOptions(disabledList);
        setOptions(options);
    }, [disabledList]);

    return (
        <Select {...rest}
            options={options}
            onChange={(val) => props.onChange && props.onChange(val)}>
        </Select>
    );
}

export default UOMSelect;
